export default __webpack_public_path__ + "65fba4fd415fc6ff26582ec4912d6875.svg";